"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _setState = require("./setState");
Object.keys(_setState).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _setState[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _setState[key];
    }
  });
});